
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A1628] text-white py-16 border-t border-[#D4AF37]/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-4xl font-serif font-bold mb-4">Cr.edit</h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              삶의 모호함 위에 선명한 '점(.)'을 찍는 출판사<br />
              크레딧입니다.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#D4AF37]">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#philosophy" className="text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  출판 철학
                </a>
              </li>
              <li>
                <a href="#track-record" className="text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  출간 도서
                </a>
              </li>
              <li>
                <a href="#process" className="text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  출판 프로세스
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
                  원고 투고
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-[#D4AF37]">Contact</h4>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-[#D4AF37]"></i>
                <a href="mailto:dahae@creditworks.co.kr" className="hover:text-[#D4AF37] transition-colors cursor-pointer">
                  dahae@creditworks.co.kr
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-[#D4AF37]/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-300 text-sm">
            © 2026 Cr.edit
          </p>
          <div className="flex gap-6 text-sm">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-[#D4AF37] transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
